var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button upload-images",attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v("Update your Details")])}
var staticRenderFns = []

export { render, staticRenderFns }